import React from 'react';
import { PageLayout } from '../../components/layout/PageLayout';

export default function Connect() {
  return (
    <PageLayout
      heroLogoSrc="/products/paygent-connect-logo.png"
      title="API Platform"
      subtitle="The embedded finance infrastructure for SaaS platforms and vertical software."
      badge="EMBEDDED FINANCE"
      imageSrc="/products/art_connect_1776905084670.png"
    >
      <div className="mt-16 bg-gradient-to-br from-indigo-50 to-blue-50 p-10 rounded-[2.5rem] border border-blue-100">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl font-extrabold text-gray-900 mb-4">Board Merchants Instantly</h2>
          <p className="text-gray-600 text-lg">Use the Pathfinder API to completely automate underwriting and onboarding within your own application.</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white p-6 rounded-2xl shadow-sm border border-white">
            <h4 className="font-bold text-gray-900 mb-2">Automated Underwriting</h4>
            <p className="text-sm text-gray-600">Zero-friction onboarding lets your users accept payments within minutes, not days.</p>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow-sm border border-white">
            <h4 className="font-bold text-gray-900 mb-2">Split Payments</h4>
            <p className="text-sm text-gray-600">Route funds between multiple parties automatically and handle complex marketplace payouts.</p>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow-sm border border-white">
            <h4 className="font-bold text-gray-900 mb-2">White-Label Control</h4>
            <p className="text-sm text-gray-600">Maintain your brand identity. You control the UI, we handle the compliance and routing.</p>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
